import React from 'react'
import './About.css'
import About_Me_Cards from './About_Me_Cards'
import MissionCards from './MissionCards'
import SkillCards from './SkillCards'
import Footer from'./Footer'
import certificateImg from '../jpegs/WhatsApp Image 2026-08-16 at 2.13.39 PM.jpeg'
import my_img from '../jpegs/images.jpg'
// certificate image — copy your certificate file into src/assets (or similar)
// and import it here, e.g:
// import certificateImg from './assets/itu-certificate.jpg'

const About = () => {
  return (
    <>
      {/* ---------- intro / hero ---------- */}
      <section className="about-hero">
        <div className="about-hero-photo">
          <About_Me_Cards />
        </div>
        <div className="about-hero-text">
          <div className="section-tag">
            <hr />
            <span>.about me</span>
          </div>
          <h1 className="about-hero-name">Hi, I'm Abdulsamad Kamran</h1>
          <p className="about-hero-bio">
            I'm a Certified Web Developer and IoT enthusiast who loves building things that live at
            the intersection of software and hardware — from fast, modern websites to devices that
            talk to the cloud. I care about clean code, thoughtful design, and shipping things that
            actually work.
          </p>
          <div className="about-badges">
            <span className="about-badge">✓ ITU Certified — Web Development</span>
            <span className="about-badge">IoT Developer</span>
            <span className="about-badge">Available for Work</span>
          </div>
        </div>
      </section>

      {/* ---------- what i do ---------- */}
      <section className="services-section">
        <div className="section-tag">
          <hr />
          <span>.what i do</span>
        </div>
        <h2 className="section-title">What I Do</h2>

        <div className="services-grid">
          <div className="service-card">
            <div className="service-icon">🖥</div>
            <h4>Web Development</h4>
            <p>Responsive, fast websites and web apps built with React, Node.js, and modern tooling.</p>
          </div>
          <div className="service-card">
            <div className="service-icon">🎨</div>
            <h4>UI / Frontend Design</h4>
            <p>Clean, intuitive interfaces with smooth animations that make products feel alive.</p>
          </div>
          <div className="service-card">
            <div className="service-icon">🔌</div>
            <h4>IoT Development</h4>
            <p>Connected devices and embedded systems using ESP8266 and STM32F407 hardware.</p>
          </div>
          <div className="service-card">
            <div className="service-icon">⚙</div>
            <h4>Backend & APIs</h4>
            <p>Reliable server-side logic and databases with Node.js, Express, and MongoDB/SQL.</p>
          </div>
        </div>
      </section>

      {/* ---------- mission ---------- */}
      <section className="missionMain">
        <div className="section-tag">
          <hr />
          <span>.mission</span>
        </div>
        <h2 className="section-title">What Drives Me</h2>

        <div className="mission-grid">
          <MissionCards number="01" title="— Responsive Design" desc="Websites that look great and work smoothly on phones, tablets, and desktops." />
          <MissionCards number="02" title="— User Friendly" desc="Simple, intuitive interfaces that make it easy for anyone to navigate and use." />
          <MissionCards number="03" title="— Clean & Maintainable Code" desc="Well-structured code that's easier to understand, extend, and fix." />
          <MissionCards number="04" title="— Fast Performance" desc="Lightweight and optimized websites that load quickly and feel smooth." />
          <MissionCards number="05" title="— Interactive Experiences" desc="Engaging animations and interactions that make websites feel modern and alive." />
          <MissionCards number="06" title="— Keep Learning" desc="Always exploring new technologies and better ways to build for the web." />
        </div>
      </section>

      {/* ---------- certification ---------- */}
      <section className="certification-section">
        <div className="section-tag">
          <hr />
          <span>.certification</span>
        </div>
        <h2 className="section-title">Certified Web Developer</h2>

        <div className="cert-card">
          <div className="cert-image-wrap">
            {/* replace src="#" with your imported certificate image */}
            <img src={certificateImg} alt="ITU Web Development Certificate" className="cert-image" />
          </div>
          <div className="cert-info">
            <span className="cert-badge">VERIFIED</span>
            <h3>Certificate of Participation — Web Development</h3>
            <p className="cert-issuer">
              Information Technology University of the Punjab (ITU) · Centre of Executive Trainings
            </p>
            <p className="cert-desc">
              Successfully completed the Web Development course at ITU's Centre of Executive
              Trainings, covering front-end and back-end fundamentals, modern JavaScript, and
              real-world project building.
            </p>
            <div className="cert-meta">
              <div>
                <span className="cert-meta-label">DURATION</span>
                <span className="cert-meta-value">July 2025 – September 2025</span>
              </div>
              <div>
                <span className="cert-meta-label">REFERENCE</span>
                <span className="cert-meta-value">ITU/CET/B12/053</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* ---------- skills (staggered / masonry layout) ---------- */}
      <section className='skillsMain'>
        <div className='section-tag'>
          <hr />
          <span>.skills</span>
        </div>
        <h2 className="section-title">What I Work With</h2>
        <div className="skills-masonry">
          <SkillCards name="HTML" pct={90} category="FRONTEND" />
          <SkillCards name="React/NextJs" pct={98} category="FRONTEND" />
          <SkillCards name="CSS" pct={85} category="FRONTEND" />
          <SkillCards name="ESP8266" pct={98} category="IOT / SERVER COMM." />
          <SkillCards name="JavaScript" pct={80} category="FRONTEND/BACKEND" />
          <SkillCards name="Node.js" pct={80} category="BACKEND" />
          <SkillCards name="STM32F407" pct={80} category="IOT DEVICES" />
          <SkillCards name="WordPress" pct={90} category="CMS" />
          <SkillCards name="Express.js" pct={75} category="BACKEND" />
          <SkillCards name="Vite" pct={85} category="FRONTEND" />
          <SkillCards name="MongoDB/SQL" pct={70} category="BACKEND" />
        </div>
      </section>
      <Footer/>
    </>
  )
}

export default About
